// Generate a number between 0-1 based on a string
export function hashString(str: string = ''): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }
  // Normalize to 0-1
  return (hash & 0xFFFFFFFF) / 0xFFFFFFFF;
} 